var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isAuthenticated)?_c('main-menu'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"default-opacity-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }